import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-request-consultation',
  templateUrl: './request-consultation.component.html',
  styleUrls: ['./request-consultation.component.scss']
})
export class RequestConsultationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
